// 导入基础组件
import Button from './Button/index.js';
import Menu from './Menu/index.js';
import Tabs from './Tabs/index.js';
import Carousel from './Carouse/index.js';
import Logo from './Logo/index.js';

// 导出所有组件
export {
  Button,
  Menu,
  Tabs,
  Carousel,
  Logo
};

// 组件列表
const components = [
  Button,
  Menu,
  Tabs,
  Carousel,
  Logo
];

// 默认导出安装函数
export default {
  install(app) {
    components.forEach(component => {
      app.use(component);
    });
  }
}; 